import React from "react";
//import TermsPopup from "./terms";
import TermsPopup from "./terms updated"
import PrivacyPolicyPopup from "./Privacy uodated";
import { useClient } from "ClientContext";

export interface FormData {
  guest: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
  };
  card?: {
    cardholderName: string;
    cardNumber: string;
    expirationYear: string;
    expirationMonth: string;
    cvv: string;
  };
  policy: {
    privacy: {
      dateOfAcceptance: Date;
      isAccepted: boolean;
      version: number;
    };
    termsAndConditions: {
      isAccepted: boolean;
      dateOfAcceptance: Date;
    };
    marketing: {
      isAccepted: boolean;
    };
  };
}

interface ContactDetailsProps {
  formData: FormData;
  handleContactChange: (data: FormData) => void;
}

const ContactDetails: React.FC<ContactDetailsProps> = ({
  formData,
  handleContactChange,
}) => {
  const { clientName,internal_ID } = useClient();
  const [isPrivacyPolicyVisible, setIsPrivacyPolicyVisible] = React.useState(false);
  const [isTermsVisible, setIsTermsVisible] = React.useState(false);

  // Directly update the parent's state on change
  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value, type } = e.target;
    const isCheckbox = type === "checkbox";

    // We assume guest-related fields match keys on formData.guest.
    handleContactChange({
      ...formData,
      guest: {
        ...formData.guest,
        [name]: isCheckbox ? (e.target as HTMLInputElement).checked : value,
      },
    });
  };

  // Handle changes for nested policy fields.
  const handlePolicyChange = (
    policyKey: keyof FormData["policy"],
    value: boolean
  ) => {
    handleContactChange({
      ...formData,
      policy: {
        ...formData.policy,
        [policyKey]: {
          ...formData.policy[policyKey],
          isAccepted: value,
          dateOfAcceptance: new Date(),
        },
      },
    });
  };

  return (
    <>
      <h2 className="text-lg font-semibold text-neutral-800 dark:text-neutral-200">
        Your Contact Details
      </h2>

      {/* Email */}
      <div>
        <label
          htmlFor="email"
          className="block text-sm text-neutral-500 dark:text-neutral-400"
        >
          Email (required)
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.guest.email || ""}
          onChange={handleInputChange}
          placeholder="Enter your email"
          className="mt-1 block w-full border border-neutral-200 dark:border-neutral-700 rounded-lg p-2.5 text-neutral-800 dark:text-neutral-200 bg-white dark:bg-neutral-800 focus:border-primary-500 focus:ring-2 focus:ring-primary-500 focus:outline-none"
          required
        />
      </div>

      {/* First Name and Last Name */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label
            htmlFor="firstName"
            className="block text-sm text-neutral-500 dark:text-neutral-400"
          >
            First Name (required)
          </label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={formData.guest.firstName || ""}
            onChange={handleInputChange}
            placeholder="First name"
            className="mt-1 block w-full border border-neutral-200 dark:border-neutral-700 rounded-lg p-2.5 text-neutral-800 dark:text-neutral-200 bg-white dark:bg-neutral-800 focus:border-primary-500 focus:ring-2 focus:ring-primary-500 focus:outline-none"
            required
          />
        </div>
        <div>
          <label
            htmlFor="lastName"
            className="block text-sm text-neutral-500 dark:text-neutral-400"
          >
            Last Name (required)
          </label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={formData.guest.lastName || ""}
            onChange={handleInputChange}
            placeholder="Last name"
            className="mt-1 block w-full border border-neutral-200 dark:border-neutral-700 rounded-lg p-2.5 text-neutral-800 dark:text-neutral-200 bg-white dark:bg-neutral-800 focus:border-primary-500 focus:ring-2 focus:ring-primary-500 focus:outline-none"
            required
          />
        </div>
      </div>

      {/* Phone Number */}
      <div>
        <label
          htmlFor="phoneNumber"
          className="block text-sm text-neutral-500 dark:text-neutral-400"
        >
          Phone Number
        </label>
        <input
          type="tel"
          id="phoneNumber"
          name="phone"
          value={formData.guest.phone || ""}
          onChange={handleInputChange}
          placeholder="+1 (555) 555-5555"
          className="mt-1 block w-full border border-neutral-200 dark:border-neutral-700 rounded-lg p-2.5 text-neutral-800 dark:text-neutral-200 bg-white dark:bg-neutral-800 focus:border-primary-500 focus:ring-2 focus:ring-primary-500 focus:outline-none"
          required
        />
      </div>

      {/* Privacy Policy Checkbox */}
      <div className="flex items-center space-x-2">
        <input
          type="checkbox"
          id="privacyPolicy"
          checked={formData.policy.privacy.isAccepted}
          onChange={(e) => handlePolicyChange("privacy", e.target.checked)}
          className="h-4 w-4 border border-primary-500 rounded text-primary-500 focus:ring-primary-500"
        />
        <label
          htmlFor="privacyPolicy"
          className="text-sm text-neutral-500 dark:text-neutral-400"
        >
          I have read and accept the{" "}
          <button
            type="button"
            onClick={() => setIsPrivacyPolicyVisible(true)}
            className="text-primary-500 underline"
          >
            Privacy Policy
          </button>
        </label>
      </div>

      {/* Terms & Conditions Checkbox */}
      <div className="flex items-center space-x-2">
        <input
          type="checkbox"
          id="termsAndConditions"
          checked={formData.policy.termsAndConditions.isAccepted}
          onChange={(e) => handlePolicyChange("termsAndConditions", e.target.checked)}
          className="h-4 w-4 border border-primary-500 rounded text-primary-500 focus:ring-primary-500"
        />
        <label
          htmlFor="termsAndConditions"
          className="text-sm text-neutral-500 dark:text-neutral-400"
        >
          I have read and accept the{" "}
          <button
            type="button"
            onClick={() => setIsTermsVisible(true)}
            className="text-primary-500 underline"
          >
            Terms & Conditions
          </button>
        </label>
      </div>

      {/* Marketing Checkbox */}
      <div className="flex items-center space-x-2">
        <input
          type="checkbox"
          id="marketing"
          checked={formData.policy.marketing.isAccepted}
          onChange={(e) => handlePolicyChange("marketing", e.target.checked)}
          className="h-4 w-4 border border-primary-500 rounded text-primary-500 focus:ring-primary-500"
        />
        <label
          htmlFor="marketing"
          className="text-sm text-neutral-500 dark:text-neutral-400"
        >
          I am interested in updates on special offers, promotions, and news from {clientName}.
        </label>
      </div>

      {isPrivacyPolicyVisible && (
        <PrivacyPolicyPopup internalId={internal_ID} onClose={() => setIsPrivacyPolicyVisible(false)} />
      )}
      {isTermsVisible && (
        <TermsPopup internalId={internal_ID} onClose={() => setIsTermsVisible(false)} />
      )}
    </>
  );
};

export default ContactDetails;